import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVerticalAlignmentRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVerticalAlignmentRight"><Path d="M21 3H19V21H21V3Z" fill="currentColor"/><Path d="M3 6V11H17V6H3Z" fill="currentColor"/><Path d="M7 13V18H17V13H7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVerticalAlignmentRight;
